<template lang="pug">
  .budgeting-info
    button.button.is-outlined.is-small(@click="show = !show") Summen nach Kategorien
    transition(name="slide-fade-down")
      .data(v-if="show")
        Spinner(v-if="panel.loading" :size="10" :thickness="2")
        form(v-else @submit.prevent)
          Spinner.updating(v-if="panel.updating" :size="10" :thickness="2")
          .tree
            ProductCategoryTree(
              info
              :tree="tree"
              :data="panel.data"
              :budget="budget"
              :currency="currency"
            )
</template>

<script>
import BudgetingTool from './';
export default {
    name: 'BudgetingInfo',
    extends: BudgetingTool,
    data: () => ({
        show: false
    })
};
</script>

<style lang="sass" scoped>
.checkout-stepper
  .budgeting-info
    display: flex
    flex-direction: column
    justify-content: flex-end
    align-items: flex-end
    .panel
      max-width: 400px
    .button
      margin: 20px 0
    .tree
      overflow-y: auto
      display: grid
      grid-template-columns: auto repeat(2, max-content)
      font-size: 0.8rem
      &::v-deep
        ul, li, .product-category-tree
          display: contents

    ::v-deep
      .is-parent
        & >
          .label, .qty, .sum
            padding-top: 20px
            font-weight: normal
      .is-first
        & >
          .label, .qty, .sum
            padding-top: 20px
      .qty, .sum
        padding-left: 10px
        min-width: 80px
        justify-content: flex-end
        font-weight: bold
        display: flex
        align-items: center
      .qty
        font-weight: normal
</style>
